// Simple API base URL export for x402 payment endpoints
// Paywall component handles all x402 client setup internally

const isLocal = import.meta.env.VITE_LOCAL === 'true' || window.location.hostname === 'localhost';

export const API_BASE_URL = isLocal
  ? "http://localhost:8402"
  : "https://cryptoz.cards:8402";
